/* eslint-disable react/jsx-no-literals */
import React, { useCallback, useEffect } from "react";
import { LoadingScreen } from "web-ui";

import styles from "../styles/SearchTTS.module.scss";

import { Error } from "./Error";
import { NavigationConfirmationDrawer } from "./NavigationConfirmationDrawer";
import type { QueryResults } from "./Query";
import { Query } from "./Query";
import { SearchTTSResults } from "./SearchTTSResults";

const SearchTTS = () => {
  const [ttsDataQueryResults, setTtsDataQueryResults] =
    React.useState<QueryResults>();
  const [error, setError] = React.useState<string>();
  const [isSearching, setIsSearching] = React.useState(false);
  const [showLoading, setShowLoading] = React.useState(false);

  const [
    showNavigationConfirmationDrawerVisible,
    setShowNavigationConfirmationDrawerVisible,
  ] = React.useState(false);
  const [isNewSearchAllowed, setIsNewSearchAllowed] = React.useState(true);

  useEffect(() => {
    if (isSearching) {
      const timeout = setTimeout(() => {
        setShowLoading(true);
      }, 2000);

      return () => {
        clearTimeout(timeout);
      };
    } else {
      setShowLoading(false);

      return () => 0;
    }
  }, [isSearching]);

  const onQueryResult = useCallback((queryResults: QueryResults) => {
    setTtsDataQueryResults(queryResults);
    setError(undefined);
    setIsSearching(false);
  }, []);

  const onQueryError = useCallback((e: string) => {
    setTtsDataQueryResults(undefined);
    setError(e);
    setIsSearching(false);
  }, []);

  const onSubmit = useCallback(() => {
    setIsSearching(true);
  }, []);

  const onBlockedSubmit = useCallback(
    () => setShowNavigationConfirmationDrawerVisible(true),
    [],
  );

  return (
    <div className={styles["wrap"]}>
      <Query
        isSearchAllowed={isNewSearchAllowed}
        onBlockedSubmit={onBlockedSubmit}
        onError={onQueryError}
        onResult={onQueryResult}
        onSubmit={onSubmit}
      />
      {error ? (
        <Error subject={error} />
      ) : showLoading ? (
        <div className={styles["loading-wrapper"]}>
          <LoadingScreen
            isVisible={showLoading}
            localizer={() => "Loading"}
            text="Are you logged in? Open duolingo.com and login before coming back."
          />
        </div>
      ) : ttsDataQueryResults === undefined ? null : ttsDataQueryResults.data
          .length > 0 ? (
        <SearchTTSResults
          allowNewSearch={setIsNewSearchAllowed}
          ttsDataResults={ttsDataQueryResults}
        />
      ) : (
        <Error subject="No results" />
      )}
      <NavigationConfirmationDrawer
        isVisible={showNavigationConfirmationDrawerVisible}
        onDismiss={() => setShowNavigationConfirmationDrawerVisible(false)}
        onNavigateAnyways={() => {
          setIsNewSearchAllowed(true);
        }}
      />
    </div>
  );
};

export default SearchTTS;
